import React from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const MusicNoteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-4 h-4"
  >
    <path
      d="M6.66667 14C5.93333 14 5.30556 13.7389 4.78333 13.2167C4.26111 12.6944 4 12.0667 4 11.3333C4 10.6 4.26111 9.97222 4.78333 9.45C5.30556 8.92778 5.93333 8.66667 6.66667 8.66667C6.92222 8.66667 7.15833 8.69722 7.375 8.75833C7.59167 8.81944 7.8 8.91111 8 9.03333V2.66667C8 2.47778 8.06389 2.31944 8.19167 2.19167C8.31944 2.06389 8.47778 2 8.66667 2H11.3333C11.5222 2 11.6806 2.06389 11.8083 2.19167C11.9361 2.31944 12 2.47778 12 2.66667V4C12 4.18889 11.9361 4.34722 11.8083 4.475C11.6806 4.60278 11.5222 4.66667 11.3333 4.66667H9.33333V11.3333C9.33333 12.0667 9.07222 12.6944 8.55 13.2167C8.02778 13.7389 7.4 14 6.66667 14Z"
      fill={colors.text.primary}
    />
  </svg>
);

const FolderIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-4 h-4"
  >
    <path
      d="M2.16667 2H4.88889C5.25611 2 5.60189 2.17289 5.82222 2.46667L6.28889 3.08889C6.50922 3.38266 6.85501 3.55556 7.22222 3.55556H13.8333C14.4777 3.55556 15 4.07789 15 4.72222V12.8889C15 13.5332 14.4777 14.0556 13.8333 14.0556H2.16667C1.52233 14.0556 1 13.5332 1 12.8889V3.16667C1 2.52233 1.52233 2 2.16667 2Z"
      fill={colors.text.primary}
    />
  </svg>
);

const AdditionalOptions = ({ songTitle = "", workspace = "My Workspace", onSongTitleChange, onWorkspaceClick }) => {
  return (
    <>
      <style>{`
        .song-title-input::placeholder {
          color: ${colors.text.inactive};
        }
      `}</style>
      <div className="flex flex-col w-full overflow-hidden gap-px rounded-2xl">
      {/* Song Title Row */}
      <div 
        className="flex justify-start items-center w-full h-14 relative gap-2 px-4"
        style={{ backgroundColor: colors.bg.fog.thin }}
      >
        <MusicNoteIcon />
        <input
          type="text"
          value={songTitle}
          onChange={(e) => onSongTitleChange?.(e.target.value)}
          placeholder="Song Title"
          className="song-title-input flex-1 bg-transparent border-none focus:outline-none"
          style={{
            ...typography.small.regular,
            color: songTitle ? colors.text.primary : colors.text.inactive,
            caretColor: colors.accent
          }}
        />
      </div>

      {/* Workspace Row */}
      <div 
        className="flex justify-between items-center w-full h-14 px-4"
        style={{ backgroundColor: colors.bg.fog.thin }}
      >
        <div className="flex justify-start items-center relative gap-2">
          <FolderIcon />
          <p style={{ ...typography.small.regular, color: colors.text.primary }}>
            Workspace
          </p>
        </div>
        <div 
          className="flex justify-center items-center h-10 relative gap-1 px-4 rounded-full cursor-pointer hover:opacity-80 transition-opacity"
          style={{ backgroundColor: colors.bg.tertiary }}
          onClick={onWorkspaceClick}
        >
          <p className="text-xs font-medium whitespace-nowrap" style={{ color: colors.text.primary }}>
            {workspace}
          </p>
        </div>
      </div>
      </div>
    </>
  );
};

export default AdditionalOptions;